import Dashboard from "../../common/components/layout/Dashboard";
import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import { StockInventorytable } from "./StockInventorytable";

export function StockInventoryPage() {
  return (
    <ToastProvider>
      <Dashboard>
        <StockInventorytable />
        <Toast />
      </Dashboard>
    </ToastProvider>
  );
}
